import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { push } from "connected-react-router";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { CustomColumnType } from "../grid-column-types";
import { isCurrentRowTheFooter } from "../utils";
import { EntityType } from "api/ux/src";
import { getTextWidth } from "common/html-width-helpers";
import { useCurrentDashboardType } from "components/workspaces/hooks/use-current-dashboard";
import { appInsightEvents } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setDashboardOptions } from "store/current-dashboard";
import { useIsEditMode } from "store/template/designer/selectors";
import { getCurrentLocalTime } from "common/date-utils";
const extractDestinationEntityInfoFromPath = (path) => {
    if (path?.includes(EntityType.Asset.toString().toLowerCase())) {
        return EntityType.Asset;
    }
    if (path?.includes(EntityType.Fund.toString().toLowerCase())) {
        return EntityType.Fund;
    }
    if (path?.includes(EntityType.Manager.toString().toLowerCase())) {
        return EntityType.Manager;
    }
    if (path?.includes(EntityType.Market.toString().toLowerCase())) {
        return EntityType.Market;
    }
    return EntityType.Portfolio;
};
export const broadcastAppInsightsNavigationEvent = (path, currentDashboardType) => {
    if (currentDashboardType) {
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.NavigationFromGrid, properties: { LocalTimestamp: getCurrentLocalTime() } }, {
            originEntityLevel: currentDashboardType,
            targetEntityLevel: extractDestinationEntityInfoFromPath(path)
        });
    }
    else {
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.NavigationFromMainGrid, properties: { LocalTimestamp: getCurrentLocalTime() } }, { entityLevel: EntityType.Fund });
    }
};
export const createLink = (mappings, data) => {
    if (data[mappings.id]) {
        const link = `${mappings.path}${data[mappings.id]}`;
        const params = [];
        const options = {};
        for (const param of mappings.params) {
            if (data[param.field]) {
                params.push(`${param.name}=${data[param.field]}`);
                options[`selected${param.name[0].toUpperCase()}${param.name.substring(1)}`] = data[param.field];
            }
        }
        return { link: params.length ? `${link}?${params.join("&")}` : link, options };
    }
    return {};
};
const getLinkDisplayProps = (params, mappings) => {
    const customIcon = mappings?.icon;
    const needsIcon = params.colDef?.type?.includes(CustomColumnType.InsExternalLinkIconColumn);
    return {
        icon: customIcon || (needsIcon ? "link" : undefined),
        isExternalLink: mappings?.path && mappings.path.startsWith("http"),
        showLabel: !customIcon,
        textWidth: getTextWidth(params.value) ?? 100
    };
};
export const DatapointLinkCellRenderer = (params) => {
    const currentDashboardType = useCurrentDashboardType(), dispatch = useDispatch(), isEditMode = useIsEditMode(), widgets = useSelector((state) => state.entities.Widget);
    const { widgetId } = params;
    if (isCurrentRowTheFooter(params.node) && params.context.displayTotals && params.value !== undefined) {
        return React.createElement(React.Fragment, null, params.value);
    }
    const colField = params.colDef?.field;
    if (!colField || !(params?.data && (colField in params.data) && params.data[colField])) {
        return React.createElement(React.Fragment, null);
    }
    const context = params.context;
    const mappings = context?.linksMapping?.find((m) => m.field === colField);
    if (!mappings || context?.noLinks) {
        return React.createElement(React.Fragment, null, params.value || "");
    }
    const { icon, isExternalLink, showLabel, textWidth } = getLinkDisplayProps(params, mappings);
    return React.createElement("div", { style: showLabel ? { width: `${textWidth}px` } : { display: "inline-block" } },
        React.createElement(AuxButton, { type: AuxButtonTypeEnum.TERTIARY, icon: icon, style: {}, onClick: (event) => {
                const currentWidget = Object.values(widgets).filter((w) => w.id === widgetId)
                    .at(0);
                if (currentWidget?.metaData?.PreqinBenchmarkLinkClicked) {
                    appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.PreqinBenchmarkLinkClicked,
                        properties: { LocalTimestamp: getCurrentLocalTime(), nameOfBenchmarkClicked: params.value } });
                }
                if (mappings.customOnClick) {
                    mappings.customOnClick(params);
                    return;
                }
                broadcastAppInsightsNavigationEvent(mappings.path, currentDashboardType);
                const { link, options } = createLink(mappings, params.data);
                if (link) {
                    batch(() => {
                        if (isExternalLink ||
                            (event && (event.metaKey || event.ctrlKey || event.button === 1))) {
                            window.open(link, "_blank");
                        }
                        else {
                            dispatch(push(link));
                            if (options) {
                                dispatch(setDashboardOptions(options));
                            }
                        }
                    });
                }
            }, isDisabled: isEditMode || Boolean(mappings.isDisabled), label: showLabel ? params.value : undefined }));
};
